// // import React from 'react';
// // import { Check } from 'lucide-react';
// // import { detailedFeatures } from '../mockData';

// // const DetailedFeatures = () => {
// //   return (
// //     <section className="py-28 px-6 bg-gradient-to-b from-gray-50 to-white">
// //       <div className="max-w-7xl mx-auto">
// //         <div className="text-center mb-24">
// //           <p className="text-brand-blue-600 text-sm font-bold mb-6 tracking-wide uppercase">{detailedFeatures.badge}</p>
// //           <h2 className="text-5xl md:text-6xl font-bold mb-8 leading-tight">{detailedFeatures.title}</h2>
// //           <p className="text-xl text-gray-600 max-w-3xl mx-auto">{detailedFeatures.subtitle}</p>
// //         </div>

// //         <div className="space-y-32">
// //           {detailedFeatures.items.map((item, index) => (
// //             <div key={index} className={`flex flex-col ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} gap-16 items-center`}>
// //               <div className="flex-1 space-y-6">
// //                 <p className="text-brand-green-600 text-sm font-bold tracking-wide uppercase">{item.category}</p>
// //                 <h3 className="text-4xl md:text-5xl font-bold leading-tight">{item.title}</h3>
// //                 <p className="text-xl text-gray-600 leading-relaxed">{item.tagline}</p>
// //                 <ul className="space-y-5 pt-4">
// //                   {item.features.map((feature, fIndex) => (
// //                     <li key={fIndex} className="flex items-start space-x-4">
// //                       <div className="w-8 h-8 rounded-full bg-brand-green-100 flex items-center justify-center flex-shrink-0 mt-1">
// //                         <Check className="w-5 h-5 text-brand-green-600 font-bold" />
// //                       </div>
// //                       <span className="text-gray-700 text-lg leading-relaxed">{feature}</span>
// //                     </li>
// //                   ))}
// //                 </ul>
// //               </div>
// //               <div className="flex-1">
// //                 <div className="rounded-3xl overflow-hidden shadow-2xl hover:shadow-3xl transition-shadow duration-500 transform hover:scale-105 transition-transform duration-700">
// //                   <img src={item.image} alt={item.title} className="w-full h-auto" />
// //                 </div>
// //               </div>
// //             </div>
// //           ))}
// //         </div>
// //       </div>
// //     </section>
// //   );
// // };

// // export default DetailedFeatures;

// import React from 'react';
// import { Check } from 'lucide-react';
// import { detailedFeatures } from '@/mockData';

// const DetailedFeatures = () => {
//   return (
//     // DIUBAH: Dihapus 'bg-gradient-to-b from-gray-50 to-white'
//     <section className="py-28 px-6">
//       <div className="max-w-7xl mx-auto">
//         <div className="text-center mb-24">
//           {/* Badge ini sudah OK */}
//           <p className="text-brand-blue-400 text-sm font-bold mb-6 tracking-wide uppercase">{detailedFeatures.badge}</p>
//           {/* DIUBAH: Teks judul diubah menjadi 'text-white' */}
//           <h2 className="text-5xl md:text-6xl font-bold mb-8 leading-tight text-white">{detailedFeatures.title}</h2>
//           {/* DIUBAH: Teks subjudul diubah menjadi 'text-gray-300' */}
//           <p className="text-xl text-gray-300 max-w-3xl mx-auto">{detailedFeatures.subtitle}</p>
//         </div>

//         <div className="space-y-32">
//           {detailedFeatures.items.map((item, index) => (
//             <div key={index} className={`flex flex-col ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} gap-16 items-center`}>
//               <div className="flex-1 space-y-6">
//                 {/* Badge ini sudah OK */}
//                 <p className="text-brand-green-500 text-sm font-bold tracking-wide uppercase">{item.category}</p>
//                 {/* DIUBAH: Teks judul item diubah menjadi 'text-white' */}
//                 <h3 className="text-4xl md:text-5xl font-bold leading-tight text-white">{item.title}</h3>
//                 {/* DIUBAH: Teks tagline diubah menjadi 'text-gray-300' */}
//                 <p className="text-xl text-gray-300 leading-relaxed">{item.tagline}</p>
//                 <ul className="space-y-5 pt-4">
//                   {item.features.map((feature, fIndex) => (
//                     <li key={fIndex} className="flex items-start space-x-4">
//                       {/* Checkbox ini sudah OK */}
//                       <div className="w-8 h-8 rounded-full bg-brand-green-100 flex items-center justify-center flex-shrink-0 mt-1">
//                         <Check className="w-5 h-5 text-brand-green-600 font-bold" />
//                       </div>
//                       {/* DIUBAH: Teks fitur diubah menjadi 'text-gray-200' */}
//                       <span className="text-gray-200 text-lg leading-relaxed">{feature}</span>
//                     </li>
//                   ))}
//                 </ul>
//               </div>
//               <div className="flex-1">
//                 <div className="rounded-3xl overflow-hidden shadow-2xl hover:shadow-3xl transition-shadow duration-500 transform hover:scale-105 transition-transform duration-700">
//                   <img src={item.image} alt={item.title} className="w-[70%] h-auto" />
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default DetailedFeatures;

import React from 'react';
import { Check } from 'lucide-react';
import { detailedFeatures } from '@/mockData';

const DetailedFeatures = () => {
  return (
    // DIUBAH: Dihapus 'bg-gradient-to-b from-gray-50 to-white'
    <section className="py-28 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-24">
          {/* Badge ini sudah OK */}
          <p className="text-brand-blue-400 text-sm font-bold mb-6 tracking-wide uppercase">{detailedFeatures.badge}</p>
          {/* DIUBAH: Teks judul diubah menjadi 'text-white' */}
          <h2 className="text-5xl md:text-6xl font-bold mb-8 leading-tight text-white">{detailedFeatures.title}</h2>
          {/* DIUBAH: Teks subjudul diubah menjadi 'text-gray-300' */}
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">{detailedFeatures.subtitle}</p>
        </div>

        <div className="space-y-32">
          {detailedFeatures.items.map((item, index) => (
            <div key={index} className={`flex flex-col ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} gap-16 items-center`}>
              <div className="flex-1 space-y-6">
                {/* Badge ini sudah OK */}
                <p className="text-brand-green-500 text-sm font-bold tracking-wide uppercase">{item.category}</p>
                {/* DIUBAH: Teks judul item diubah menjadi 'text-white' */}
                <h3 className="text-4xl md:text-5xl font-bold leading-tight text-white">{item.title}</h3>
                {/* DIUBAH: Teks tagline diubah menjadi 'text-gray-300' */}
                <p className="text-xl text-gray-300 leading-relaxed">{item.tagline}</p>
                <ul className="space-y-5 pt-4">
                  {item.features.map((feature, fIndex) => (
                    <li key={fIndex} className="flex items-start space-x-4">
                      {/* Checkbox ini sudah OK */}
                      <div className="w-8 h-8 rounded-full bg-brand-green-100 flex items-center justify-center flex-shrink-0 mt-1">
                        <Check className="w-5 h-5 text-brand-green-600 font-bold" />
                      </div>
                      {/* DIUBAH: Teks fitur diubah menjadi 'text-gray-200' */}
                      <span className="text-gray-200 text-lg leading-relaxed">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
              {/* --- PERUBAHAN DI SINI --- */}
              {/* 1. Parent 'flex-1' diberi 'flex justify-center items-center' agar bisa memusatkan div gambar */}
              <div className="flex-1 flex justify-center items-center">
                {/* 2. Wrapper gambar ini sekarang responsif: w-full di mobile, md:w-[70%] di desktop */}
                <div className="rounded-3xl overflow-hidden shadow-2xl hover:shadow-3xl transition-shadow duration-500 transform hover:scale-105 transition-transform duration-700 w-full md:w-[70%]">
                  {/* 3. Gambar di dalam tetap w-full agar mengisi wrapper-nya */}
                  <img src={item.image} alt={item.title} className="w-full h-auto" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DetailedFeatures;